module.exports = __webpack_public_path__ + "img/infographic_latest.21f9ad17.png";